module.exports = __webpack_public_path__ + "static/media/dyslexia.bf0c4cb1.png";